/**
 * Display-edge time formatting (CLAUDE.md rule 12): every API value the SPA
 * receives is a UTC epoch millis number. `formatLondon` converts it to the
 * viewer's zone for the visible label ("17 Sept 2026, 14:05 BST"); `isoUtc`
 * gives the unambiguous UTC instant for a `title` tooltip alongside it. The
 * SPA never encodes a fixed offset as if it were a zone.
 */

// Split into two formatters rather than one call with dateStyle + timeStyle +
// timeZoneName together: some Intl implementations reject that exact
// combination (observed on Node 25's ICU). Formatting the date/time and
// looking up the zone abbreviation separately produces the same string and
// works everywhere.
const londonDateTime = new Intl.DateTimeFormat("en-GB", {
  timeZone: "Europe/London",
  dateStyle: "medium",
  timeStyle: "short",
});
const londonZoneOnly = new Intl.DateTimeFormat("en-GB", {
  timeZone: "Europe/London",
  timeZoneName: "short",
});

function londonZoneAbbr(d: Date): string {
  const part = londonZoneOnly.formatToParts(d).find((p) => p.type === "timeZoneName");
  return part ? part.value : "";
}

/** "17 Sept 2026, 14:05 BST" — Europe/London, labelled with its own zone. */
export function formatLondon(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return "—";
  const d = new Date(ms);
  const zone = londonZoneAbbr(d);
  return zone ? `${londonDateTime.format(d)} ${zone}` : londonDateTime.format(d);
}

/** "2026-09-17T13:05:00.000Z" — the unambiguous UTC instant, for a tooltip. */
export function isoUtc(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return "—";
  return new Date(ms).toISOString();
}
